import React, { useState } from 'react'
import VideoPanel  from '../Components/VideoPanel'
import Navbar from '../Components/Navbar';
import Upload from '../Components/Upload'
import Filter from '../Components/Filter'
import SearchField from '../Components/SearchField'

export const Dashboard = () => {
  const [videos, setVideos] = useState([]);

  return (
    <div>
        <Navbar 
          Upload={<Upload/>} 
          Filter={<Filter setVideos={setVideos}/>} 
          SearchField={<SearchField setVideos={setVideos}/>}/>
        <VideoPanel videos={videos} setVideos={setVideos}/>
    </div>
  )
}
